"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _constants = require("./constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typographyTypes = require("./typographyTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.typography-code-01 {\n  font-family: \"SourceCodeProRegular\";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.02rem; }\n\n.typography-button-label {\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-label-01 {\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  line-height: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.02rem; }\n\n.typography-label-02 {\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  line-height: 1rem;\n  font-weight: 600;\n  letter-spacing: 0.02rem; }\n\n.typography-caption-01 {\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  line-height: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.02rem; }\n\n.typography-helper-text-01 {\n  font-family: \"OpenSansRegular\";\n  font-size: 0.75rem;\n  line-height: 1rem;\n  font-weight: 400;\n  letter-spacing: 0.02rem; }\n\n.typography-page-title {\n  font-family: \"OpenSansRegular\";\n  font-size: 1.375rem;\n  line-height: 1.625rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-page-section-header {\n  font-family: \"OpenSansRegular\";\n  font-size: 1.25rem;\n  line-height: 1.625rem;\n  font-weight: 400; }\n\n.typography-body-text {\n  font-family: \"OpenSansRegular\";\n  font-size: 1rem;\n  line-height: 1.375rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-heading-07 {\n  font-family: \"OpenSansRegular\";\n  font-size: 0.875rem;\n  line-height: 1.125rem;\n  font-weight: 600;\n  letter-spacing: 0.01rem; }\n\n.typography-heading-06 {\n  font-family: \"OpenSansRegular\";\n  font-size: 1rem;\n  line-height: 1.375rem;\n  font-weight: 600;\n  letter-spacing: 0rem; }\n\n.typography-heading-05 {\n  font-family: \"OpenSansRegular\";\n  font-size: 1.25rem;\n  line-height: 1.625rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-heading-04 {\n  font-family: \"OpenSansRegular\";\n  font-size: 1.75rem;\n  line-height: 2.25rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-heading-03 {\n  font-family: \"OpenSansRegular\";\n  font-size: 2rem;\n  line-height: 2.5rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-heading-02 {\n  font-family: \"OpenSansRegular\";\n  font-size: 2.625rem;\n  line-height: 3.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-heading-01 {\n  font-family: \"OpenSansRegular\";\n  font-size: 3.375rem;\n  line-height: 4rem;\n  font-weight: 400;\n  letter-spacing: 0rem; }\n\n.typography-button-label,\n.typography-caption-01,\n.typography-helper-text-01,\n.typography-label-01,\n.typography-label-02 {\n  display: block; }\n\n.typography-heading-01,\n.typography-heading-02,\n.typography-heading-03,\n.typography-heading-04,\n.typography-heading-05,\n.typography-heading-06,\n.typography-heading-07,\n.typography-page-title,\n.typography-page-section-header,\n.typography-body-text {\n  margin: 0; }\n";
  var fileName = "compone_typography";
  var element = document.querySelector("style[data-sass-component='compone_typography']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Typography = function Typography(props) {
  var typographyProps = {
    variant: props.variant,
    children: props.children,
    dataAttribute: props[_constants.dataAttributeName]
  };
  return /*#__PURE__*/_react.default.createElement(TypographyComponent, typographyProps);
};

var TypographyComponent = function TypographyComponent(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      dataAttribute = _ref.dataAttribute;

  switch (variant) {
    case _constants.typographyVariants.buttonLabel:
    case _constants.typographyVariants.label1:
    case _constants.typographyVariants.label2:
    case _constants.typographyVariants.caption1:
    case _constants.typographyVariants.helperText1:
      return (0, _typographyTypes.spanTexts)({
        variant: variant,
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.bodyText:
      return (0, _typographyTypes.bodyText)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.code1:
      return (0, _typographyTypes.code1)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.pageTitle:
      return (0, _typographyTypes.pageTitle)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.pageSectionHeader:
      return (0, _typographyTypes.pageSectionHeader)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading1:
      return (0, _typographyTypes.heading1)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading2:
      return (0, _typographyTypes.heading2)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading3:
      return (0, _typographyTypes.heading3)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading4:
      return (0, _typographyTypes.heading4)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading5:
      return (0, _typographyTypes.heading5)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading6:
      return (0, _typographyTypes.heading6)({
        children: children,
        dataAttribute: dataAttribute
      });

    case _constants.typographyVariants.heading7:
      return (0, _typographyTypes.heading7)({
        children: children,
        dataAttribute: dataAttribute
      });

    default:
      return null;
  }
};

TypographyComponent.propTypes = {
  variant: _propTypes.default.oneOf(['code1', 'button', 'label1', 'label2', 'caption1', 'helper1', 'pageTitle', 'pageSectionHeader', 'body', 'heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6', 'heading7']).isRequired,
  dataAttribute: _propTypes.default.string
};
var _default = Typography;
exports.default = _default;